/* return coverage for a specific date
   for an employee and their policies */

class PolicyDates {
  constructor (participations, policies, date) {
    this.participations = participations;
    this.policies = policies;
    this.date = new Date(date) || new Date();
  }

  policiesEndedBeforeDate () {
    return this.policies.filter(
      p => p.dateEnded != null && this.date > new Date(p.dateEnded));
  }

  participationsEndedBeforeDate () {
    return this.participations.filter(
      p => p.untilDate != null && this.date > new Date(p.untilDate));
  }

  participationsStartedAfterDate () {
    return this.participations.filter(
      p => this.date < new Date(p.fromDate) && !p.isActiveWaiverOnDate(p.fromDate));
  }

  policiesStartedAfterDate () {
    return this.policies.filter(
      p => this.date < new Date(p.dateStarted));
  }

  participationsActiveOnDate () {
    return this.participations.filter(
      p => p.isActiveOnDate(this.date) && !p.isActiveWaiverOnDate(this.date));
  }

  policiesActiveOnDate () {
    return this.policies.filter(p => p.isActiveOnDate(this.date));
  }

  participationsOnDate () {
    return this.participations.filter(p =>
      new Date(p.fromDate) >= this.date &&
      (p.untilDate == null || this.date <= new Date(p.untilDate)) &&
      !p.hasActiveWaiverOnDate(this.date));
  }

  policiesOnDate () {
    this.policies.filter(p =>
      new Date(p.dateStarted) >= this.date &&
      (p.dateEnded == null || this.date <= new Date(p.dateEnded)));
  }

  getAll () {
    return {
      participations: {
        before: this.participationsEndedBeforeDate(),
        after: this.participationsStartedAfterDate(),
        active: this.participationsActiveOnDate()

      },
      policies: {
        before: this.policiesEndedBeforeDate(),
        after: this.policiesStartedAfterDate(),
        active: this.policiesActiveOnDate()
      }
    };
  }
}

export {
  PolicyDates as default
};
